import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import Federate from "../Containers/federate";
import Config from "./Config";
import ConfiguracionRI from "./configurationRI";
import Bulletin from "./bulletin";
import { route } from "../Utils/constants.js";
import iniciarConfiguracionAPI from "../Services/configAwsInit.js";
import { ProtectedRoute } from "../Components/privateRoute";
import { ProtectedRouteAdmin } from "../Components/protectedRouteAdmin";
import Panel from "../Components/panel";
import { useSelector, useDispatch } from "react-redux";
import NestedRoutersSimulate from "../Components/childrenRoutes";
import NestedRoutersAprovations from "../Components/childrenRoutesAprovations";
import SecureInvestmentIncome from "../Containers/SecureInvestmentIncome";
import AsuredData from "../Containers/asuredData";
import ContratantData from "../Containers/contratantData";
import InvestmentProfile from "../Containers/investmentProfile";
import { removeAll, removeAssured } from "./../Store/data/actions";
import { WithRouter } from "../Utils/WithRouter";
import NestedRoutersQuotations from "../Components/childrenRoutesQuotations";

const Routers = ({ active, closePanel }) => {
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.login.granted);
  const recommendedProduct = useSelector((state) => state.recommended);
  const channel = useSelector((state) => state.login.channel);
  const access_configuration = useSelector(
    (state) => state.login.access_configuration
  );

  const cleanData = () => {
    dispatch(removeAll());
    dispatch(removeAssured());
  };
  const cleanAction = () => {
    if (
      Object.keys(recommendedProduct).length === 0 &&
      recommendedProduct.constructor === Object
    )
      cleanData();
    if (recommendedProduct.recommended) {
      if (Object.keys(recommendedProduct.recommended).length === 0) cleanData();
    }
  };
  useEffect(() => {
    iniciarConfiguracionAPI();
  }, []);

  return (
    <>
      <Panel
        active={active}
        closePanel={closePanel}
        channel={channel}
        isLogin={isLogin}
      />
      <WithRouter />
      <Switch>
        <Route path={route.PATH} component={Federate} />
            <Route path={route.ASURED_DATA} component={AsuredData} />
            <Route path={route.CONTRATANT_DATA} component={ContratantData} />
            <Route
              path={route.INVESTMENT_PROFILE}
              component={InvestmentProfile}
            />
            <ProtectedRoute
              path={route.PRODUCTS}
              granted={isLogin}
              component={SecureInvestmentIncome}
              channel={channel}
              clean={cleanAction}
            />
            <NestedRoutersSimulate path={route.SIMULATIONS} />
            <NestedRoutersQuotations path={route.QUOTES} />
            <NestedRoutersAprovations path={route.APROVATIONS} />
            <ProtectedRouteAdmin
              path={route.CONFIG_AS}
              granted={isLogin}
              component={Config}
              isAdmin={access_configuration}
            />
            <ProtectedRouteAdmin
              path={route.CONFIG_RI}
              granted={isLogin}
              component={ConfiguracionRI}
              isAdmin={access_configuration}
            />
            <ProtectedRouteAdmin
              path={route.BULLETIN}
              granted={isLogin}
              component={Bulletin}
              isAdmin={access_configuration}
            />
      </Switch>
    </>
  );
};

export default Routers;
